var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
const SvgForbiddenStubc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 254 294"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E4EBF7",
  fillRule: "evenodd",
  d: "M0 127.273v-2.101C0 56.042 56.387 0 125.943 0h2.114C197.613 0 254 56.042 254 125.172v2.102c0 69.131-56.387 125.173-125.943 125.173h-2.114C56.387 252.448 0 196.405 0 127.274",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M40.107 130.79a8.26 8.26 0 0 1-.935 3.119 8.304 8.304 0 0 1-2.07 2.521 8.39 8.39 0 0 1-9.276.896 8.334 8.334 0 0 1-2.52-2.078 8.253 8.253 0 0 1-1.813-6.123 8.284 8.284 0 0 1 3.045-5.548 8.387 8.387 0 0 1 11.7 1.172 8.264 8.264 0 0 1 1.87 6.041Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  d: "m48.8 146.5-12.759 10.816m1.261-23.06 10.575 5.959-10.575-5.959Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M40.228 159.38a5.67 5.67 0 0 1-2.071 3.83 5.74 5.74 0 0 1-8.045-.805 5.658 5.658 0 0 1 .81-7.995 5.73 5.73 0 0 1 4.19-1.254 5.751 5.751 0 0 1 2.134.649 5.703 5.703 0 0 1 1.721 1.41 5.669 5.669 0 0 1 1.26 4.165Zm17.87-16.149a5.725 5.725 0 0 1-2.072 3.893 5.775 5.775 0 0 1-4.24 1.277 5.756 5.756 0 0 1-4.948-4.081 5.69 5.69 0 0 1-.199-2.237c.166-1.5.92-2.875 2.1-3.824a5.784 5.784 0 0 1 8.068.808 5.699 5.699 0 0 1 1.29 4.164ZM99.894 26.548l30.084-.014a4.651 4.651 0 0 0 3.272-1.349 4.587 4.587 0 0 0 1.002-5.013 4.6 4.6 0 0 0-2.506-2.489 4.65 4.65 0 0 0-1.771-.349l-30.084.013a4.653 4.653 0 0 0-3.272 1.348 4.599 4.599 0 0 0-1.355 3.254 4.576 4.576 0 0 0 1.357 3.252 4.63 4.63 0 0 0 3.273 1.347Zm11.507 18.385 30.084-.013a4.642 4.642 0 0 0 3.228-1.373 4.583 4.583 0 0 0-.003-6.457 4.64 4.64 0 0 0-3.229-1.37l-30.084.013a4.653 4.653 0 0 0-3.272 1.349 4.6 4.6 0 0 0-1.354 3.253 4.6 4.6 0 0 0 2.859 4.248c.562.231 1.163.35 1.771.35Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M113.796 26.532v-.002l15.924-.006a4.65 4.65 0 0 0-3.317 1.324 4.592 4.592 0 0 0-1.379 3.277 4.6 4.6 0 0 0 2.906 4.268c.57.228 1.179.34 1.793.33l-15.923.008v-.003a4.64 4.64 0 0 0 3.271-1.348 4.588 4.588 0 0 0 1.354-3.252 4.587 4.587 0 0 0-1.357-3.25 4.641 4.641 0 0 0-3.272-1.346Zm72.36 109.098c-.558 5.5-5.496 9.509-11.028 8.954-5.534-.554-9.567-5.462-9.009-10.961.557-5.5 5.495-9.508 11.029-8.954 5.533.555 9.567 5.462 9.009 10.961",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  d: "m194.714 156.497-15.39 13.046m1.523-27.813 12.751 7.187-12.751-7.187Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M186.302 170.113a6.815 6.815 0 0 1-.766 2.584 6.868 6.868 0 0 1-4.097 3.367 6.952 6.952 0 0 1-5.288-.531 6.866 6.866 0 0 1-3.338-4.111 6.834 6.834 0 0 1 2.291-7.249 6.921 6.921 0 0 1 9.644.967 6.824 6.824 0 0 1 1.554 4.973Zm18.837-16.777a6.895 6.895 0 0 1-2.5 4.693 6.961 6.961 0 0 1-2.402 1.278 6.999 6.999 0 0 1-5.316-.533 6.944 6.944 0 0 1-2.096-1.729 6.896 6.896 0 0 1-1.266-2.397 6.85 6.85 0 0 1-.241-2.697 6.893 6.893 0 0 1 2.533-4.615 6.972 6.972 0 0 1 5.069-1.504 6.96 6.96 0 0 1 4.664 2.479 6.874 6.874 0 0 1 1.555 5.025Z",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  d: "M153.275 192.439c0 .591-.236 1.158-.656 1.576a2.253 2.253 0 0 1-3.17 0 2.22 2.22 0 0 1 0-3.151 2.247 2.247 0 0 1 3.17 0c.42.418.656.984.656 1.575Zm73.988-76.472c0 .591-.236 1.158-.656 1.576a2.254 2.254 0 0 1-3.171 0 2.22 2.22 0 0 1 0-3.152 2.25 2.25 0 0 1 3.17 0c.42.418.656.985.656 1.576h.001Zm-8.968 35.118a2.235 2.235 0 0 1-.658 1.576 2.238 2.238 0 0 1-1.586.652 2.256 2.256 0 0 1-1.585-.653 2.225 2.225 0 0 1-.657-1.576c0-.592.237-1.158.657-1.576a2.246 2.246 0 0 1 1.586-.653c.595 0 1.165.234 1.586.653.42.418.657.984.657 1.576v.001Zm-39.813-43.561a2.221 2.221 0 0 1-1.373 2.102 2.25 2.25 0 0 1-2.954-1.234 2.222 2.222 0 0 1 .516-2.413 2.25 2.25 0 0 1 3.138 0c.419.408.661.962.673 1.545Zm18.537-15.512a2.22 2.22 0 0 1-.64 1.606 2.234 2.234 0 0 1-1.602.67 2.25 2.25 0 0 1-1.603-.67 2.21 2.21 0 0 1-.639-1.606 2.22 2.22 0 0 1 .673-1.546 2.25 2.25 0 0 1 3.138 0c.419.408.661.963.673 1.546Zm6.827 88.783a2.22 2.22 0 0 1-.657 1.576 2.25 2.25 0 0 1-3.172 0 2.224 2.224 0 0 1 0-3.152 2.25 2.25 0 0 1 3.172 0c.421.418.657.985.657 1.576Z",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  d: "m222.778 117.163-12.953 7.923-15.446-7.924v-22.92m21.923 59.07-1.929 20.238-11.025 6.006 12.954-26.244Zm-41.104 21.548-6.412 9.84h-11.461l-4.548 6.501 22.421-16.341Zm1.291-49.757v-15.847 15.847Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M168.062 65.713h-3.986a4.81 4.81 0 0 1-3.379-1.396 4.754 4.754 0 0 1-1.406-3.358 4.755 4.755 0 0 1 1.405-3.36 4.815 4.815 0 0 1 3.38-1.396h3.986a4.815 4.815 0 0 1 3.38 1.397 4.759 4.759 0 0 1 1.405 3.359 4.754 4.754 0 0 1-1.406 3.358 4.81 4.81 0 0 1-3.379 1.397Z",
  clipRule: "evenodd"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#1890FF",
  fillRule: "evenodd",
  d: "M176.37 29.71c0-16.325 13.315-29.56 29.741-29.56 16.424 0 29.741 13.235 29.741 29.56 0 16.323-13.317 29.558-29.741 29.558-16.426 0-29.741-13.235-29.741-29.559Z",
  clipRule: "evenodd"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M207.774 38.09c.505.501.792 1.145.792 1.933s-.288 1.47-.792 1.97a2.937 2.937 0 0 1-2.018.751c-.791 0-1.441-.285-1.946-.787-.577-.501-.827-1.146-.827-1.934s.25-1.432.827-1.933c.505-.501 1.155-.752 1.947-.752s1.475.25 2.017.752Zm4.323-19.515c1.441 1.252 2.162 2.97 2.162 5.156 0 1.716-.431 3.138-1.23 4.261-.067.096-.138.18-.22.266-.419.43-1.422 1.35-2.982 2.706a5.082 5.082 0 0 0-1.44 1.755 5.183 5.183 0 0 0-.541 2.363v.501h-4.144v-.501c0-1.36.217-2.543.721-3.51.468-.966 1.873-2.47 4.215-4.548l.434-.5c.648-.788.972-1.648.972-2.543 0-1.183-.361-2.113-1.009-2.792-.684-.682-1.657-1.004-2.883-1.004-1.55 0-2.665.465-3.387 1.434-.373.501-.626 1.138-.766 1.91a2.009 2.009 0 0 1-1.989 1.634h-.004c-1.288 0-2.277-1.187-1.997-2.437.339-1.522 1.029-2.787 2.091-3.794 1.549-1.504 3.639-2.256 6.305-2.256 2.341 0 4.251.608 5.692 1.899Z",
  clipRule: "evenodd"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFB594",
  fillRule: "evenodd",
  d: "M52.5 75.936s22.003 5.374 27.55 15.986c5.624 10.769-6.408 9.285-15.87 4.948-10.955-5.02-24.918-11.853-11.679-20.935Z",
  clipRule: "evenodd"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFC6A0",
  fillRule: "evenodd",
  d: "m91.284 67.286-.453 2.9c-.76.492-4.79-2.67-4.79-2.67l-1.66.75-1.358-5.699s6.876-4.601 8.996-5.031c2.474-.503 9.972.942 10.795 2.284 0 0 1.332.487-2.247.692-3.58.203-5.087.448-6.85 3.14-1.762 2.693-2.433 3.634-2.433 3.634Z",
  clipRule: "evenodd"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M129.188 111.266c-2.65-7.745-6.204-13.216-8.996-15.52-3.531-2.914-9.423-2.23-11.466-4.198-1.282-1.234-3.244-1.2-3.244-1.2S90.37 87.18 88.505 86.859c-2.39-.41-2.143-.716-6.107-1.408-1.584-1.913-2.943-1.125-2.943-1.125l-7.173-1.387c-.86-1.476-2.445-1.026-2.445-1.026l-2.49-.9c-1.659 10.003-7.808 13.834-7.808 13.834 1.81 1.125 15.842 8.322 15.842 8.322l5.152 37.209s-3.35 5.71 1.358 9.134c0 0 20.059-3.753 35.23-.33 0 0 3.074-2.553.981-8.83.527-3.018 1.406-8.285 1.751-11.653.389.774 2.037 1.923 3.168 3.486 0 0 9.49-7.384 11.15-14.049-.84-.725-1.612-1.589-2.287-2.46-.572-.738-.362-2.061-.772-2.724-.675-1.087-1.82-1.382-1.924-1.686Z",
  clipRule: "evenodd"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#CBD1D1",
  fillRule: "evenodd",
  d: "M101.984 290.376s4.333 2.046 7.419 1.023c2.846-.942 4.57.67 7.143 1.182 2.573.511 6.935 1.103 11.789-1.264-.103-5.525-6.949-3.99-12.065-6.731-2.586-1.383-3.818-4.734-3.63-8.822h-9.485s-1.405 10.548-1.171 14.612Z",
  clipRule: "evenodd"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#2B0849",
  fillRule: "evenodd",
  d: "M101.961 290.203s2.449 1.275 6.819.655c3.085-.438 3.745.482 7.488 1.034 3.745.551 10.819-.07 11.928-.897.417 1.103-.346 2.069-.346 2.069s-1.525.604-4.855.826c-2.048.136-5.851.292-7.674-.504-1.803-1.379-5.293-1.908-5.779-.242-3.952.953-7.42-.287-7.42-.287l-.161-2.654Z",
  clipRule: "evenodd"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#A4AABA",
  fillRule: "evenodd",
  d: "M109.299 276.383h3.122s-.104 6.72 4.576 8.581c-4.681.619-8.634-2.309-7.698-8.581Z",
  clipRule: "evenodd"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#CBD1D1",
  fillRule: "evenodd",
  d: "M58.05 272.73s-2.125 7.436-4.524 12.339c-1.814 3.705-4.262 7.513 5.513 7.513 6.707 0 9.033-.482 7.49-6.617-1.544-6.137.267-13.235.267-13.235h-8.745Z",
  clipRule: "evenodd"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#2B0849",
  fillRule: "evenodd",
  d: "M51.932 290.17s2.115 1.172 6.691 1.172c6.137 0 8.322-1.654 8.322-1.654s.608 1.116-.624 2.17c-1.002.858-3.63 1.596-7.456 1.55-4.181-.048-5.883-.567-6.795-1.171-.833-.551-.693-1.584-.138-2.067Z",
  clipRule: "evenodd"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#A4AABA",
  fillRule: "evenodd",
  d: "M58.936 274.64s.033 1.523-.317 2.938c-.352 1.423-1.087 3.112-1.14 4.15-.058 1.154 4.577 1.584 5.2.034.626-1.551 1.306-6.444 1.93-7.272.625-.827-4.946-2.124-5.673.151",
  clipRule: "evenodd"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#7BB2F9",
  fillRule: "evenodd",
  d: "m100.542 278.86 13.496.092s1.31-54.666 1.87-64.576c.559-9.908 3.809-43.48 1.011-63.297l-12.659-.645-23.05.782s-.439 3.976-1.206 10.002c-.064.498-.688.846-.756 1.369-.076.587.427 1.358.323 1.971-2.385 14.118-6.433 33.193-8.822 46.802-.117.668-1.244 1.012-1.47 2.699-.04.302.213 1.529.113 1.799-6.934 18.795-11.046 47.971-14.404 62.051l14.737-.014s2.216-8.593 4.065-17.015c2.836-12.921 23.316-85.238 23.316-85.238l3.042-.522 1.053 46.474s-.226 1.237.34 2.025c.565.787-.565 1.126-.396 2.25l.396 1.799s-.453 7.197-.906 11.922c-.452 4.722-.093 39.27-.093 39.27Z",
  clipRule: "evenodd"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  stroke: "#648BD8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.051,
  d: "M107.301 225.345s2.798-1.113 6.157-3.894m-36.7.368c1.163.095 4.074-2.024 7.016-4.948l-7.016 4.948Z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  stroke: "#648BD8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M108.225 222.295s2.797-1.113 6.156-3.895"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  stroke: "#648BD8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.051,
  d: "M56.616 274.752h13.428m5.357-49.784s2.645-.592 6.563-3.374l-6.563 3.374Zm11.39-73.328c-.272 3.114.303 8.547-4.374 9.147l4.374-9.147Zm17.751-1.759s.111 14.049-1.305 15.105c-2.238 1.669-3.016 1.949-3.016 1.949l4.321-17.054Zm-3.869.559s.035 12.915-1.207 24.443l1.207-24.443Zm-6.172 25.542s7.276-1.669 9.515-1.669l-9.515 1.669Zm-19.534 30.03a211.897 211.897 0 0 1-.987 4.572s-1.471 1.837-1.018 3.786c.453 1.949-.956 2.051-5.03 15.396-1.71 5.605-4.53 18.641-6.404 27.671l-.233 1.123 13.672-52.548Zm1.391-8.076c-.284 1.591-.58 3.18-.89 4.767l.89-4.767Zm6.963-45.696-1.206 10.495s-1.107.151-.505 2.25c.114 1.35-2.697 15.817-5.225 30.512l6.936-43.257Z"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#192064",
  fillRule: "evenodd",
  d: "M117.269 148.216s-17.198-3.112-36.21.201c.16 2.521-.003 4.161-.003 4.161s14.817-2.826 35.985-.313c.255-2.361.228-4.049.228-4.049Z",
  clipRule: "evenodd"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m107.263 151.17.003-4.924a.815.815 0 0 0-.785-.817 110.981 110.981 0 0 0-7.906-.014.822.822 0 0 0-.796.817l-.003 4.919a.81.81 0 0 0 .839.815c2.406-.06 5.017-.064 7.798.017a.824.824 0 0 0 .85-.812",
  clipRule: "evenodd"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#192064",
  fillRule: "evenodd",
  d: "m106.138 150.236.002-3.084a.645.645 0 0 0-.625-.648 95.697 95.697 0 0 0-5.918-.01.657.657 0 0 0-.635.649v3.08a.637.637 0 0 0 .407.601.66.66 0 0 0 .253.045 122.47 122.47 0 0 1 5.845.011.65.65 0 0 0 .671-.644Z",
  clipRule: "evenodd"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  stroke: "#648BD8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.051,
  d: "m101.88 175.033.906 44.762s.679 1.574-.227 2.699c-.905 1.125 2.49.675.906 2.249s.905 1.125 0 3.374c-.602 1.493-1.003 21.157-1.106 35.24m-1.209 12.395h12.448-12.448Zm1.184-4.898c.006 3.396.042 5.806.112 6.524l-.112-6.524Zm.015-5.998a788.09 788.09 0 0 0-.015 4.349l.015-4.349Z"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFC6A0",
  fillRule: "evenodd",
  d: "M47.29 83.25s-.52 6.062 7.287 5.567c11.3-.713 9.3-9.37 31.82-21.713-.794-2.715-2.47-4.756-2.47-4.756s-11.165 3.118-22.783 8.067c-6.826 2.908-13.514 6.37-13.854 12.835Zm58.094 7.651.949-5.386-8.962-11.461-5.082 5.386-1.755 7.855a.32.32 0 0 0 .109.321c.973.802 6.557 5.027 14.474 3.554a.337.337 0 0 0 .266-.269",
  clipRule: "evenodd"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFC6A0",
  fillRule: "evenodd",
  d: "M94.773 79.199s-4.573-2.86-2.453-6.873c1.637-3.099 4.552 1.136 4.552 1.136s.525-3.652 3.149-3.652c.525-1.043 1.575-4.173 1.575-4.173s11.546 2.608 13.646 3.13c0 5.216-2.325 19.475-7.91 19.913-8.97.705-12.559-9.481-12.559-9.481Z",
  clipRule: "evenodd"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "#520038",
  fillRule: "evenodd",
  d: "M114.882 73.243c2.624-2.087 3.501-9.748 3.501-9.748s-2.501-.492-6.699-2.056c-4.725-2.087-12.911-4.76-17.635.979-9.753 3.231-2.068 19.876-2.068 19.876l2.737-3.03s-3.97-3.295-2.098-6.259c2.189-3.471 3.954 1.076 3.954 1.076s.643-2.394 3.613-3.351c.358-.712 1.045-2.681 1.445-3.86.085-.255.263-.468.499-.599.236-.13.512-.169.775-.107 2.421.56 8.754 2.024 11.456 2.669.527.125.879.617.828 1.153l-.308 3.257Z",
  clipRule: "evenodd"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "#552950",
  fillRule: "evenodd",
  d: "M105.906 75.867c-.104.612-.587 1.04-1.079.959-.494-.084-.809-.646-.705-1.258.104-.611.588-1.04 1.08-.958.492.082.807.645.704 1.257Zm7.218 1.634c-.104.612-.587 1.041-1.079.959-.492-.083-.807-.646-.704-1.257.104-.612.587-1.041 1.079-.959.492.082.807.645.704 1.257Z",
  clipRule: "evenodd"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB836E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.118,
  d: "m111.105 74.64-.904 1.615-.301 4.369h-2.248"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  stroke: "#5C2552",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.118,
  d: "M111.827 74.28s1.806-.718 2.528.539"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB836E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.118,
  d: "M93.203 74.081s.481-1.117 1.123-.718c.643.4 1.285 1.437.563 1.996-.723.557.16 1.674.16 1.674"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  stroke: "#5C2552",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.118,
  d: "M104.201 72.725s1.846 1.116 4.174.956"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB836E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.118,
  d: "M95.531 81.023s2.329 7.42 10.516 7.66m-1.444-7.101s2.247 1.196 4.415 1.196l-4.415-1.196Zm.963 2.553s.963.399 1.525.319l-1.525-.32Z"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  stroke: "#E4EBF7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.101,
  d: "M69.61 82.475s-.732 9.306-8.276 14.244m20.837-7.496s.454 5.662-4.979 12.821l4.979-12.821Z"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  stroke: "#E4EBF7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.051,
  d: "M130.55 122.795s-5.318 7.423-9.505 10.797"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  stroke: "#E4EBF7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.101,
  d: "M120.362 107.217s.456 4.377-2.146 32.148"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2D7AD",
  fillRule: "evenodd",
  d: "M151.356 151.238h-50.278c-.271 0-.53-.107-.721-.297a1.009 1.009 0 0 1-.298-.716v-31.773c0-.558.456-1.013 1.019-1.013h50.278c.562 0 1.018.455 1.018 1.013v31.773c0 .269-.107.526-.298.716-.191.19-.45.297-.72.297Z",
  clipRule: "evenodd"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  fill: "#F4D19D",
  fillRule: "evenodd",
  d: "M151.62 151.237h-20.039v-33.798h20.968v32.874a.921.921 0 0 1-.928.923",
  clipRule: "evenodd"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2D7AD",
  fillRule: "evenodd",
  d: "M124.648 127.838H93.74a.52.52 0 0 1-.429-.818l6.436-9.137c.195-.278.515-.444.858-.444h31.367l-7.324 10.399Z",
  clipRule: "evenodd"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  fill: "#CC9B6E",
  fillRule: "evenodd",
  d: "M124.783 128.392h-24.655v-.521h24.383l7.246-10.287.428.299-7.402 10.509Z",
  clipRule: "evenodd"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  fill: "#F4D19D",
  fillRule: "evenodd",
  d: "M159.699 127.838h-18.834a2.097 2.097 0 0 1-1.674-.832l-7.219-9.567h20.141c.495 0 .959.231 1.255.624l6.75 8.944a.521.521 0 0 1-.419.832",
  clipRule: "evenodd"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  fill: "#CC9B6E",
  fillRule: "evenodd",
  d: "M159.244 128.423h-19.556l-7.926-10.503.418-.311 7.768 10.294h19.296v.52Zm-27.535 22.266-.032-8.199.523-.002.033 8.199-.524.002Z",
  clipRule: "evenodd"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  fill: "#CC9B6E",
  fillRule: "evenodd",
  d: "m131.666 139.757-.08-21.472.523-.002.081 21.472-.524.002Zm-18.8 1.152-.502-.144 1.492-5.181.503.144-1.493 5.181Zm-3.469.128-2.703-2.943 2.689-3.443.414.319-2.419 3.097 2.405 2.619-.386.351Zm8.242 0-.386-.351 2.404-2.619-2.418-3.097.413-.319 2.689 3.443-2.702 2.943Z",
  clipRule: "evenodd"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFC6A0",
  fillRule: "evenodd",
  d: "m155.681 131.846-3.141-1.965.038 3.523-1.052.093c-1.697.115-3.666.23-4.831.23-1.919 0-2.717 2.264 2.249 2.655l-2.668-.597s-2.187 1.32.508 2.306c0 0-1.594 1.22.566 2.587-.589 3.513 5.294 4.069 7.185 3.599 1.893-.471 4.271-2.365 4.527-5.173.283-3.094-.898-5.447-3.38-7.258",
  clipRule: "evenodd"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB836E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.051,
  d: "M155.046 133.535s-6.579.471-8.434.373c-1.852-.098-1.921 2.196 2.38 2.27 3.772.151 5.499-.044 5.499-.044"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB836E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.051,
  d: "M146.445 135.842c-1.867 1.349.566 2.361.566 2.361s3.508.901 6.789.619"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB836E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.051,
  d: "M53.306 89.124c3.564-.337 8.497-1.251 13.702-7.774m86.226 60.339s-6.335.111-6.789-2.138c-.225-1.349.454-1.406.454-1.406l6.335 3.544Zm-5.827-.844s-1.113 3.168 5.488 3.542l-5.488-3.542Zm5.133-10.966v3.487-3.487Z"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  fill: "#5BA02E",
  fillRule: "evenodd",
  d: "M170.058 248.583a6.724 6.724 0 0 1-4.741-1.952 6.643 6.643 0 0 1-1.964-4.713v-66.644a6.659 6.659 0 0 1 1.964-4.713 6.718 6.718 0 0 1 4.741-1.952 6.745 6.745 0 0 1 4.742 1.952 6.659 6.659 0 0 1 1.964 4.713v66.644a6.643 6.643 0 0 1-1.964 4.713 6.725 6.725 0 0 1-4.742 1.952Z",
  clipRule: "evenodd"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  fill: "#92C110",
  fillRule: "evenodd",
  d: "M178.106 247.916a6.727 6.727 0 0 1-4.741-1.952 6.643 6.643 0 0 1-1.964-4.713V207.93a6.626 6.626 0 0 1 1.934-4.765 6.705 6.705 0 0 1 2.186-1.466 6.744 6.744 0 0 1 7.356 1.466 6.65 6.65 0 0 1 1.935 4.765v33.321a6.644 6.644 0 0 1-1.965 4.713 6.724 6.724 0 0 1-4.741 1.952Z",
  clipRule: "evenodd"
})), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2D7AD",
  fillRule: "evenodd",
  d: "M188.093 294h-27.766a3.223 3.223 0 0 1-2.274-.936 3.185 3.185 0 0 1-.942-2.259v-46.258c0-.847.339-1.66.942-2.259a3.223 3.223 0 0 1 2.274-.936h27.767c.853 0 1.671.336 2.274.936.603.599.941 1.412.941 2.259v46.258c0 .847-.338 1.66-.941 2.259-.603.6-1.421.936-2.274.936",
  clipRule: "evenodd"
})), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
  stroke: "#E4EBF7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.101,
  d: "M89.767 89.32s7.844 5.399 16.747 2.85"
})));
const Memo = /*#__PURE__*/memo(SvgForbiddenStubc);
export default Memo;